export default function (image, { width, height, fit, focalX, focalY } = {}) {
    if (typeof image !== 'object') {
        return;
    }

    const src = image.src?.replace(' ', '%20');

    if (!src) {
        return;
    }

    if (!src) {
        console.warn('Image source is required');
    }

    const params = [];

    if (width) {
        params.push(`w=${width}`);
    }

    if (height) {
        params.push(`h=${height}`);
    }

    const _fit = fit || 'cover';
    const _focalX = focalX || image.focalX;
    const _focalY = focalY || image.focalY;

    if (_fit) {
        params.push(`f=${_fit}`);
    }

    if (_focalX) {
        params.push(`fx=${_focalX}`);
    }

    if (_focalY) {
        params.push(`fy=${_focalY}`);
    }

    const separator = src.includes('?') ? '&' : '?';
    const queryString = params.length ? `${separator}${params.join('&')}` : '';

    return `${src}${queryString}`;
}
